import React, { Component } from 'react';
import TableC from '../../basicElement/TableC';
import { Tabs, Button, message,Icon,Tooltip } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import format from '../../shared/format';
import Filter from './Filter';
import SideNav from '../SideNav';
import ConfigColumn from './ConfigColumn';
import '../style.less';
import moment from 'moment';
import UserDetail from './UserDetail';

const { TabPane } = Tabs;


class AnomalyProject extends Component {
    
    constructor(props) {
        super(props);
        const { searchParams,activeKey } = props;
        this.state = {
            searchParams,
            loading: false,
            sortParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
            activeKey,
            tableHeader:[],
            operation:{
                title: <div className="config_clm_oper" style={{textAlign: 'center'}}>
                    <Icon 
                        type="setting" 
                        style={{fontSize: "18px"}} 
                        onClick={this.configColumn} 
                    />
                </div>,
                dataIndex: 'operation',
                key: 'operation',
                width: 60,
                fixed: 'left',
                align: 'center',
                render: (text, record, index) => {
                    const { openChildList ,childJdeList } = record;
                    if( openChildList == undefined ) {
                        return null
                    }else {
                        return (
                            <span style={{display:'block',textAlign:'center'}}>
                                <Icon 
                                    type={ openChildList ? 'minus-square-o' : 'plus-square-o'} 
                                    onClick={() => openChildList ? 
                                        this.cloceChildList(childJdeList,index) : 
                                        this.openChildList(childJdeList,index)
                                    }
                                />
                            </span>
                        )
                    }
                    
                }
            }
            
        };
    }
    openChildList = (record,index)=>{
        const {data,pagination} = this.state;
        pagination.total=pagination.total+(Math.ceil(pagination.total/pagination.pageSize))*record.length;
        pagination.pageSize=pagination.pageSize+record.length;
        data[index].openChildList=true;
        data.splice(index+1,0,...record)
        let newData = [...data]
        this.setState({data:newData,pagination})
    }
    cloceChildList = (record,index)=>{
        const {data,pagination} = this.state;
        pagination.total=pagination.total-(Math.ceil(pagination.total/pagination.pageSize))*record.length;
        pagination.pageSize=pagination.pageSize-record.length;
        data[index].openChildList=false;
        data.splice(index+1,record.length)
        let newData = [...data]
        this.setState({data:newData,pagination})
    }
    componentDidMount() {
        this.getHeader();
    }
    configColumn = ()=>{
        return this.props.configColumn()
    }
    getDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { date } = res;
            const nowT = moment(date).format('YYYY-MM-DD HH:mm');
            const nowM = moment(date).format('YYYY-MM');
            const canMark = ( `${nowM}-28 12:00` < nowT );
            this.setState({

            defaultDate:canMark?nowM:moment(nowM).subtract(1, 'M').format('YYYY-MM')

        },()=>{
          this.loadData();
        });
        })
    }

    loadData = () => {
        const { sortParams, pagination, searchParams,defaultDate } = this.state;
        const { date, investigationMedicineType = [] } = searchParams;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.financialAnomalyReport.queryInvAbnormalList,
            data: {
                offset: current,
                limit: 10,
                ...sortParams,
                ...searchParams,
                queryType:"ALL",
                type:"ABNORMAL",
                entrance:"financeManagement",
                date:date?date:defaultDate,
                investigationMedicineType: investigationMedicineType[0],
                secondResearchProductType: investigationMedicineType[1],
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                pagination.pageSize = 10;
                datas.forEach(item=>{
                    if(item.childJdeList.length){
                        item.openChildList=false
                    }
                })
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
                const params = {...searchParams,date:date?date:defaultDate};
                this.props.setCurParams(params)
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (searchParams) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    getHeader=()=>{
        const { activeKey,operation } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.common.queryUserCustomDisplayByUserId,
            data: { type: activeKey === 'anomalyProject' ? 'INVESTIGATION_ABNORMAL' : 'INVESTIGATION_ABNORMAL_MARK' },
            dataType: 'json',
            doneResult: data => {
                const headers = data.INVESTIGATION_ABNORMAL;
                const tableHeader = [];
                headers.forEach(head => {
                    if (head.isShow !== "0") {
                        tableHeader.push(head);
                    }
                });
                this.setState({ tableHeader:this.getColumns(tableHeader) },()=>{
                    this.getDate();
                });
            }
        };
        
        $.sendRequest(options);
    }

    getColumns = (tableHeadercolumn) => {
        const { operation } = this.state;
        const columns = [
        {
            title: '业务线',
            dataIndex: 'lineOfBusiness',
            key: 'lineOfBusiness',
            fixed: 'left',
            width: 80,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'mainCode',
            key: 'mainCode',
            fixed: 'left',
            width: 120,
        },{
            title: 'JDE项目号',
            dataIndex: 'jdeCode',
            key: 'jdeCode',
            width: 120,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 150,
        }, {
            title: '合同额含税/人民币',
            dataIndex: 'jdeContractAmount',
            key: 'jdeContractAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '异常原因',
            dataIndex: 'reason',
            key: 'reason',
            width: 120,
        }, 
        {
            title: '项目类型',
            dataIndex: 'investigationGlobalType',
            key: 'investigationGlobalType',
            width: 150,
        },{
            title: '研究产品类型',
            dataIndex: 'investigationMedicineType',
            key: 'investigationMedicineType',
            width: 100,
        },{
            title: '项目分期',
            dataIndex: 'byStageName',
            key: 'byStageName',
            width: 100,
        },{
            title: '项目分类',
            dataIndex: 'typeName',
            key: 'typeName',
            width: 150,
        },
        {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 150,
        },{
            title: '计收入确认方式',
            dataIndex: 'contractTypeName',
            key: 'contractTypeName',
            width: 150,
        },{
            title: 'PM工号',
            dataIndex: 'pmCode',
            key: 'pmCode',
            width: 150,
        },{
            title: 'PM姓名',
            dataIndex: 'pm',
            key: 'pm',
            width: 100,
        },{
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 150,
        },{
            title: '项目疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 150,
        },{
            title: '领域leader',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 150,
        },{
            title: 'PML（包含大区总监）',
            dataIndex: 'pml',
            key: 'pml',
            width: 100,
        },{
            title: '服务费含税/人民币',
            dataIndex: 'cnyServiceFeeIncludeTax',
            key: 'cnyServiceFeeIncludeTax',
            width: 150,
            render: text => format('money', text),
        },{
            title: '当月是否新增补充合同',
            dataIndex: 'thisMonthHasSupplement',
            key: 'thisMonthHasSupplement',
            render: value => value==1?'是':value==0?'否':'',
            width: 80,
        },{
            title: '项目计划开始时间',
            dataIndex: 'investigationPlanBeginTime',
            key: 'investigationPlanBeginTime',
            width: 150,
        }, {
            title: '项目计划结束时间',
            dataIndex: 'investigationPlanEndTime',
            key: 'investigationPlanEndTime',
            width: 80,
        },
        {
            title: '津石计划随机（入组）数量',
            dataIndex: 'planRandomAmount',
            key: 'planRandomAmount',
            width: 100,
            render: (text , row ) => row.jdeCode !== '-'?text?text:'-':text
        },{
            title: '津石计划标准访视数',
            dataIndex: 'planVisitAmount',
            key: 'planVisitAmount',
            width: 100,
            render: (text , row ) => row.jdeCode !== '-'?text?text:'-':text
        },{
            title: '累计完成随机（入组）数',
            dataIndex: 'totalRandomAmount',
            key: 'totalRandomAmount',
            width: 100,
            render: (text , row ) => row.jdeCode !== '-'?text?text:'-':text
        },{
            title: '累计完成标准访视数',
            dataIndex: 'totalVisitAmount',
            key: 'totalVisitAmount',
            width: 100,
            render: (text , row ) => row.jdeCode !== '-'?text?text:'-':text
        },{
            title: '当月新增入组例数',
            dataIndex: 'thisMonthInGroupAmount',
            key: 'thisMonthInGroupAmount',
            width: 100,
            render: (text , row ) => row.jdeCode !== '-'?text?text:'-':text
        },{
            title: (
                <span>
                    启动比例
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'实际启动中心数/津石计划负责中心数量'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'siteStartPercent',
            key: 'siteStartPercent',
            width: 100,
        },{
            title: (
                <span>
                    标准访视数完成比例
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'累计完成标准访视数/津石计划标准访视数'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'visitAmountPercent',
            key: 'visitAmountPercent',
            width: 100,
        },{
            title: (
                <span>
                    截止当月服务费回款比例
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'费用类型为服务费的回款记录'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'thisMonthServiceFeeTotalPercent',
            key: 'thisMonthServiceFeeTotalPercent',
            width: 100,
        },{
            title: (
                <span>
                    截止上月服务费回款比例
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'费用类型为服务费的回款记录'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'lastMonthServiceFeeTotalPercent',
            key: 'lastMonthServiceFeeTotalPercent',
            width: 100,
        }, 
        {
            title: '截止本月POC%',
            dataIndex: 'poc',
            key: 'poc',
            width: 100,
        }, {
            title: '截止上月POC%',
            dataIndex: 'lastPoc',
            key: 'lastPoc',
            width: 100,
        }, {
            title: '本月完工%',
            dataIndex: 'completed',
            key: 'completed',
            width: 90,
        }, {
            title: '当月服务费收入不含税/人民币',
            dataIndex: 'cnyCurrentMonthIncomeNoTax',
            key: 'cnyCurrentMonthIncomeNoTax',
            width: 120,
        }, 
        // {
        //     title: 'PM',
        //     dataIndex: 'pm',
        //     key: 'pms',
        //     width: 120,
        //     render: (text, record, index) => {
        //         const {pm,pmId}=record;
        //         let node=null;
        //         if(pm){
        //         const pmNames = pm.split(",")||[];
        //         const pmIds = pmId.split(",")||[];
        //         let pmArry=[];
        //         pmNames.map(item => {
        //              pmArry.push({
        //                     name: item,
        //                 });
        //         });
        //         pmIds.map((item,index) => {
        //             pmArry[index].id=item
        //        });
        //        node = pmArry.map((i,k) => 
        //        <a onClick={()=>this.props.showPersonInfo(i.id)} key={k}>{i.name}
        //        {((k+1)< pmArry.length)&&<a>；</a>}
        //        </a>);
        //         }
        //      return node
        //    },
        // }, {
        //     title: 'PML',
        //     dataIndex: 'pml',
        //     key: 'pmls',
        //     width: 120,
        //     render: (text, record, index) => {
        //         const {pml,pmlId}=record;
        //         let node =null;
        //         if(pml){
        //         const pmlNames = pml.split(",")||[];
        //         const pmlIds = pmlId.split(",")||[];
        //         let pmlArry=[];
        //         pmlNames.map(item => {
        //              pmlArry.push({
        //                     name: item,
        //                 });
        //         });
        //         pmlIds.map((item,index) => {
        //             pmlArry[index].id=item
        //        });
        //        node = pmlArry.map((i,k) => 
        //        <a onClick={()=>this.props.showPersonInfo(i.id)} key={k}>{i.name}
        //        {((k+1)< pmlArry.length)&&<a>；</a>}
        //        </a>);
        //         }
        //      return node
        //    },
        // }
    ];
        let result=[operation]
        tableHeadercolumn.forEach(item => {
            const { isShow, dataIndex } = item;
            if (isShow === '1' || showAll) {
                const column = columns.find(i => i.dataIndex === dataIndex) || {};
                result.push(column);
            }
        });
    return result;
    }
    

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination, sortParams,tableHeader } = this.state;
        const scrollY = (document.body || document.documentElement).clientHeight - 300;
        return (
            <TableC
                data={data}
                loading={loading}
                sortParams={sortParams}
                columns={tableHeader}
                className="anomalyProject"
                pagination={pagination}
                scrollY={scrollY}
                onChange={this.handleTableChange}
            />
        );
    }
}

class MarkNormalProject extends Component {
    constructor(props) {
        super(props);
        const { searchParams,activeKey } = props;
        this.state = {
            data: [],
            searchParams,
            loading: false,
            sortParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
            activeKey,
            tableHeader:[],
            operation:{
                title: <div className="config_clm_oper" style={{textAlign: 'center'}}>
                    <Icon 
                        type="setting" 
                        style={{fontSize: "18px"}} 
                        onClick={this.configColumn} 
                    />
                </div>,
                dataIndex: 'operation',
                key: 'operation',
                width: 60,
                fixed: 'left',
                align: 'center',
                render: (text, record, index) => {
                    const { openChildList ,childJdeList } = record;
                    if( openChildList == undefined ) {
                        return null
                    }else {
                        return (
                            <span style={{display:'block',textAlign:'center'}}>
                                <Icon 
                                    type={ openChildList ? 'minus-square-o' : 'plus-square-o'} 
                                    onClick={() => openChildList ? 
                                        this.cloceChildList(childJdeList,index) : 
                                        this.openChildList(childJdeList,index)
                                    }
                                />
                            </span>
                        )
                    }
                    
                }
            }
        };
    }

    openChildList = (record,index)=>{
        const {data,pagination} = this.state;
        pagination.total=pagination.total+(Math.ceil(pagination.total/pagination.pageSize))*record.length;
        pagination.pageSize=pagination.pageSize+record.length;
        data[index].openChildList=true;
        data.splice(index+1,0,...record)
        let newData = [...data]
        this.setState({data:newData,pagination})
    }
    cloceChildList = (record,index)=>{
        const {data,pagination} = this.state;
        pagination.total=pagination.total-(Math.ceil(pagination.total/pagination.pageSize))*record.length;
        pagination.pageSize=pagination.pageSize-record.length;
        data[index].openChildList=false;
        data.splice(index+1,record.length)
        let newData = [...data]
        this.setState({data:newData,pagination})
    }

    componentDidMount() {
        this.getHeader()
    }

    configColumn = ()=>{
        return this.props.configColumn()
    }

    getDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { date } = res;
            const nowT = moment(date).format('YYYY-MM-DD HH:mm');
            const nowM = moment(date).format('YYYY-MM');
            const canMark = ( `${nowM}-28 12:00` < nowT );
            this.setState({

            defaultDate:canMark?nowM:moment(nowM).subtract(1, 'M').format('YYYY-MM')

        },()=>{
          this.loadData();
        });
        })
    }

    getHeader=()=>{
        const { activeKey } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.common.queryUserCustomDisplayByUserId,
            data: { type: activeKey === 'anomalyProject' ? 'INVESTIGATION_ABNORMAL' : 'INVESTIGATION_ABNORMAL_MARK' },
            dataType: 'json',
            doneResult: data => {
                const headers = data.INVESTIGATION_ABNORMAL_MARK;
                const tableHeader = [];
                headers.forEach(head => {
                    if (head.isShow !== "0") {
                        tableHeader.push(head);
                    }
                });
                this.setState({ tableHeader:this.getColumns(tableHeader) },()=>{
                    this.getDate();
                });
            }
        };
        
        $.sendRequest(options);
    }

    loadData = () => {
        const { sortParams, pagination, searchParams,defaultDate } = this.state;
        const { current, pageSize } = pagination;
        const { date, investigationMedicineType = [] } = searchParams;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.financialAnomalyReport.queryInvAbnormalList,
            data: {
                offset: current,
                limit: 10,
                ...sortParams,
                ...searchParams,
                queryType:"ALL",
                type:"NORMAL",
                entrance:"financeManagement",
                date:date?date:defaultDate,
                investigationMedicineType: investigationMedicineType[0],
                secondResearchProductType: investigationMedicineType[1],
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                pagination.pageSize = 10;
                datas.forEach(item=>{
                    if(item.childJdeList.length){
                        item.openChildList=false
                    }
                })
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
                const params = {...searchParams,date:date?date:defaultDate};
                this.props.setCurParams(params)
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (searchParams) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    getColumns = (tableHeadercolumn) => {
        const { operation } = this.state;
        const columns = [
        {
            title: '业务线',
            dataIndex: 'lineOfBusiness',
            key: 'lineOfBusiness',
            fixed: 'left',
            width: 80,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'mainCode',
            key: 'mainCode',
            fixed: 'left',
            width: 120,
        },{
            title: 'JDE项目号',
            dataIndex: 'jdeCode',
            key: 'jdeCode',
            width: 120,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 100,
        }, {
            title: '合同额含税/人民币',
            dataIndex: 'jdeContractAmount',
            key: 'jdeContractAmount',
            width: 100,
        }, {
            title: '异常原因',
            dataIndex: 'reason',
            key: 'reason',
            width: 120,
        }, 
        {
            title: '项目类型',
            dataIndex: 'investigationGlobalType',
            key: 'investigationGlobalType',
            width: 150,
        },{
            title: '研究产品类型',
            dataIndex: 'investigationMedicineType',
            key: 'investigationMedicineType',
            width: 100,
        },{
            title: '项目分期',
            dataIndex: 'byStageName',
            key: 'byStageName',
            width: 100,
        },{
            title: '项目分类',
            dataIndex: 'typeName',
            key: 'typeName',
            width: 150,
        },
        {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 150,
        },{
            title: '计收入确认方式',
            dataIndex: 'contractTypeName',
            key: 'contractTypeName',
            width: 150,
        },{
            title: 'PM工号',
            dataIndex: 'pmCode',
            key: 'pmCode',
            width: 150,
        },{
            title: 'PM姓名',
            dataIndex: 'pm',
            key: 'pm',
            width: 150,
        },{
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 150,
        },{
            title: '项目疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 150,
        },{
            title: '领域leader',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 150,
        },{
            title: 'PML（包含大区总监）',
            dataIndex: 'pml',
            key: 'pml',
            width: 150,
        },{
            title: '服务费含税/人民币',
            dataIndex: 'cnyServiceFeeIncludeTax',
            key: 'cnyServiceFeeIncludeTax',
            width: 150,
            render: text => format('money', text),
        },{
            title: '当月是否新增补充合同',
            dataIndex: 'thisMonthHasSupplement',
            key: 'thisMonthHasSupplement',
            render: value => value==1?'是':value==0?'否':'',
            width: 150,
        },{
            title: '项目计划开始时间',
            dataIndex: 'investigationPlanBeginTime',
            key: 'investigationPlanBeginTime',
            width: 150,
        }, {
            title: '项目计划结束时间',
            dataIndex: 'investigationPlanEndTime',
            key: 'investigationPlanEndTime',
            width: 80,
        },
        {
            title: '津石计划随机（入组）数量',
            dataIndex: 'planRandomAmount',
            key: 'planRandomAmount',
            width: 100,
            render: (text , row ) => row.jdeCode !== '-'?text?text:'-':text
        },{
            title: '津石计划标准访视数',
            dataIndex: 'planVisitAmount',
            key: 'planVisitAmount',
            width: 100,
            render: (text , row ) => row.jdeCode !== '-'?text?text:'-':text
        },{
            title: '累计完成随机（入组）数',
            dataIndex: 'totalRandomAmount',
            key: 'totalRandomAmount',
            width: 100,
            render: (text , row ) => row.jdeCode !== '-'?text?text:'-':text
        },{
            title: '累计完成标准访视数',
            dataIndex: 'totalVisitAmount',
            key: 'totalVisitAmount',
            width: 100,
            render: (text , row ) => row.jdeCode !== '-'?text?text:'-':text
        },{
            title: '当月新增入组例数',
            dataIndex: 'thisMonthInGroupAmount',
            key: 'thisMonthInGroupAmount',
            width: 100,
            render: (text , row ) => row.jdeCode !== '-'?text?text:'-':text
        },{
            title: (
                <span>
                    启动比例
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'实际启动中心数/津石计划负责中心数量'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'siteStartPercent',
            key: 'siteStartPercent',
            width: 100,
        },{
            title: (
                <span>
                    标准访视数完成比例
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'累计完成标准访视数/津石计划标准访视数'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'visitAmountPercent',
            key: 'visitAmountPercent',
            width: 100,
        },{
            title: (
                <span>
                    截止当月服务费回款比例
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'费用类型为服务费的回款记录'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'thisMonthServiceFeeTotalPercent',
            key: 'thisMonthServiceFeeTotalPercent',
            width: 100,
        },{
            title: (
                <span>
                    截止上月服务费回款比例
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'费用类型为服务费的回款记录'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'lastMonthServiceFeeTotalPercent',
            key: 'lastMonthServiceFeeTotalPercent',
            width: 100,
        }, 
        {
            title: '截止本月POC%',
            dataIndex: 'poc',
            key: 'poc',
            width: 100,
        }, {
            title: '截止上月POC%',
            dataIndex: 'lastPoc',
            key: 'lastPoc',
            width: 100,
        }, {
            title: '本月完工%',
            dataIndex: 'completed',
            key: 'completed',
            width: 90,
        }, {
            title: '当月服务费收入不含税/人民币',
            dataIndex: 'cnyCurrentMonthIncomeNoTax',
            key: 'cnyCurrentMonthIncomeNoTax',
            width: 120,
        },{
            title: '标记时间',
            dataIndex: 'markTime',
            key: 'markTime',
            width: 90,
        }, {
            title: '标记人',
            dataIndex: 'markUserName',
            key: 'markUserName',
            width: 90,
        }
        , {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            width: 90,
        } 
        // {
        //     title: 'PM',
        //     dataIndex: 'pm',
        //     key: 'pms',
        //     width: 120,
        //     render: (text, record, index) => {
        //         const {pm,pmId}=record;
        //         let node=null;
        //         if(pm){
        //         const pmNames = pm.split(",")||[];
        //         const pmIds = pmId.split(",")||[];
        //         let pmArry=[];
        //         pmNames.map(item => {
        //              pmArry.push({
        //                     name: item,
        //                 });
        //         });
        //         pmIds.map((item,index) => {
        //             pmArry[index].id=item
        //        });
        //        node = pmArry.map((i,k) => 
        //        <a onClick={()=>this.props.showPersonInfo(i.id)} key={k}>{i.name}
        //        {((k+1)< pmArry.length)&&<a>；</a>}
        //        </a>);
        //         }
        //      return node
        //    },
        // }, {
        //     title: 'PML',
        //     dataIndex: 'pml',
        //     key: 'pmls',
        //     width: 120,
        //     render: (text, record, index) => {
        //         const {pml,pmlId}=record;
        //         let node =null;
        //         if(pml){
        //         const pmlNames = pml.split(",")||[];
        //         const pmlIds = pmlId.split(",")||[];
        //         let pmlArry=[];
        //         pmlNames.map(item => {
        //              pmlArry.push({
        //                     name: item,
        //                 });
        //         });
        //         pmlIds.map((item,index) => {
        //             pmlArry[index].id=item
        //        });
        //        node = pmlArry.map((i,k) => 
        //        <a onClick={()=>this.props.showPersonInfo(i.id)} key={k}>{i.name}
        //        {((k+1)< pmlArry.length)&&<a>；</a>}
        //        </a>);
        //         }
        //      return node
        //    },
        // }
    ];
        let result=[operation]
        tableHeadercolumn.forEach(item => {
            const { isShow, dataIndex } = item;
            if (isShow === '1' || showAll) {
                const column = columns.find(i => i.dataIndex === dataIndex) || {};
                result.push(column);
            }
        });
    return result;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination, sortParams,tableHeader } = this.state;
        const scrollY = (document.body || document.documentElement).clientHeight - 300;
        return (
            <TableC
                data={data}
                loading={loading}
                sortParams={sortParams}
                columns={tableHeader}
                className="markNormalProject"
                pagination={pagination}
                scrollY={scrollY}
                onChange={this.handleTableChange}
            />
        );
    }
}

class FinancialAnomalyReport extends Component {
    state = {
        panes: [{
            title: '财务异常项目',
            key: 'anomalyProject',
            content: null,
        }, {
            title: '标记为正常项目',
            key: 'markNormalProject',
            content: null,
        }],
        activeKey: 'anomalyProject',
        searchParams: {
          
        },
        curParams: {
            //date:moment().format('YYYY-MM')
        },
        operable:true,
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    componentDidMount() {
        this.updatePanes();
        //this.queryApprovalUser();
    }

        //  // 查询财务管理权限
        //  queryApprovalUser = () => {
        //     const options = {
        //         method: 'POST',
        //         url: API_URL.contract.queryApprovalUser,
        //         data: { type: 'FIN_MODULE,TEACH_LEADER' },
        //         dataType: 'json',
        //         doneResult: res => {
        //             this.setState({
        //                 menuAuth:res
        //             });
        //         },
        //     };
        //     $.sendRequest(options);
        // }
              


    search = (params) => {
            this.setState({
                curParams: {...params}
            }, () => {
                const { curParams } = this.state;
                this.childRef.search(curParams);
            });
    }

    configColumn =()=>{
        this.configColumnRef.show()
    }
    
    setCurParams=(params)=>{
        this.setState({
            curParams: {...params}
        })
    }

    export = () => {
        const { curParams,activeKey } = this.state;
        const url = API_URL.financialAnomalyReport.exportInvAbnormalList;
        ExportUtil.export({ ...curParams,queryType:"ALL",type:(activeKey=="anomalyProject"?"ABNORMAL":"NORMAL") }, null, url);
    }

    updatePanes = () => {
        const { panes, activeKey, curParams } = this.state;
        let RenderContent = null;
        if (activeKey == 'anomalyProject') {
            RenderContent = AnomalyProject;
        } else if (activeKey == 'markNormalProject') {
            RenderContent = MarkNormalProject;
        }
        panes.forEach(item => {
            if (item.key == activeKey) {
                item.content = <RenderContent ref={el => this.childRef = el} activeKey={activeKey} searchParams={curParams}
                showPersonInfo={this.showPersonInfo}
                setCurParams={this.setCurParams}
                configColumn={this.configColumn}
                />;
            } else {
                item.content = null;
            }
        });
        this.setState({ panes });
    }

    handleTabsChange = (activeKey) => {
        this.setState({
            activeKey,
        }, () => {
            this.updatePanes();
        });
    }

    showPersonInfo=(userId)=>{
        this.userDetailRef.show(userId);
    }
    getHeader = () => {
        this.childRef.getHeader();
    }

    render() {
        const { loading, searchParams, operable,panes, activeKey } = this.state;
        return (
            <div className="content">
                <SideNav selectKey="financialAnomalyReport" />
                <div className="main">
                    <Filter
                        operable={operable}
                        export={this.export}
                        search={this.search}
                        searchParams={searchParams}
                    />
                <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                    {panes.map(pane => <TabPane tab={pane.title} key={pane.key} disabled={pane.disabled}>{pane.content}</TabPane>)}
                </Tabs>
                <UserDetail ref={el => this.userDetailRef = el} />
                <ConfigColumn ref={el => this.configColumnRef = el} activeKey={activeKey} loadData={this.getHeader} />
                </div>
            </div>
        );
    }
}

export default FinancialAnomalyReport;


// WEBPACK FOOTER //
// ./src/components/financeManagement/financialAnomalyReport/index.js